import { Sparkles } from "lucide-react";

interface LogoProps {
  className?: string;
  iconSize?: number;
  textSize?: string;
}

const Logo = ({ className = "", iconSize = 24, textSize = "text-2xl" }: LogoProps) => {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <div className="relative">
        <Sparkles className="text-primary" size={iconSize} />
        <div className="absolute inset-0 animate-pulse">
          <Sparkles className="text-primary opacity-50" size={iconSize} />
        </div>
      </div>
      <span className={`font-bold text-primary ${textSize}`}>
        MerchMidas
      </span>
    </div>
  );
};

export default Logo;
